module.exports = __webpack_public_path__ + "static/media/연구소.123136ad.png";